export function displayDuration(seconds?: number, showHours = false): string {
  if (seconds === undefined) return '00:00';

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  if (showHours) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedRemainingMinutes = String(remainingMinutes).padStart(2, '0');

    return formattedHours + ':' + formattedRemainingMinutes + ':' + formattedSeconds;
  }

  return formattedMinutes + ':' + formattedSeconds;
}

export function convertTimeToSeconds(time: string): number {
  const [minutes, seconds] = time.split(':').map(Number);
  return minutes * 60 + seconds;
}

export function convertMillisecondsToSeconds(milliseconds: number): number {
  return Math.floor(milliseconds / 1000);
}

export function convertSecondsToMilliseconds(seconds?: number): number {
  if (!seconds) {
    return 0;
  }
  return seconds * 1000;
}
